import { unreadTranslationKeys as unreadKeysAgainst } from './bidCardTranslations';

export const LIVE_LANE_CARD_TRANSLATIONS = Object.freeze({
  live: 'Live',
  currentBid: 'current bid',
  join: 'Join lane',
});

export const unreadTranslationKeys = (translations) =>
  unreadKeysAgainst(translations, LIVE_LANE_CARD_TRANSLATIONS);

export function mergeTranslations(translations) {
  if (!translations) return LIVE_LANE_CARD_TRANSLATIONS;
  return { ...LIVE_LANE_CARD_TRANSLATIONS, ...translations };
}

export function isValidLiveLaneCardI18n(i18n) {
  if (i18n === null || typeof i18n !== 'object') return false;
  if (Object.keys(i18n).some((key) => key !== 'translations')) return false;
  if (i18n.translations === undefined) return true;
  return unreadTranslationKeys(i18n.translations).length === 0;
}
